<script>
import api from '@/helpers/api'
import { authComputed } from '@/state/helpers'
import _sortBy from 'lodash/sortBy'
export default {
  name: 'quick-add-form-btn',
  data () {
    return {
      productsData: [],
      formsData: [],
      isLoading: false,
      selectedForm: {},
      showForm: false,
      items: [
        {
          text: 'Shop',
          active: true
        }
      ]
    }
  },
  mounted () {
    this.onRefresh()
  },
  computed: {
    favoriteForms () {
      return this.formsData.filter(a => a.is_favorite)
    },
    restForms () {
      return this.formsData.filter(a => !a.is_favorite)
    },

    ...authComputed
  },
  methods: {
    setSelectedForm (form) {
      this.selectedForm = form
      this.showForm = true
    },
    async onRefresh () {
      this.isLoading = true

      let { items } = await api.items.fetchPage({
        page: 0,
        pageSize: -1,
        orderBy: [{ rating: 'desc' }, { short_description: 'asc' }],
        filters: [
          { is_webshop_item: { _eq: true } },
          { is_discontinued: { _eq: false } },
          { webshop_custom_form: { _is_null: false } }
        ]
      })

      var sortedItems = _sortBy([
        ...items.map(p => {
          return {
            ...p
          }
        })
      ])

      this.formsData = sortedItems.filter(
        item => item.webshop_custom_form !== null
      )
      this.isLoading = false
    }
  }
}
</script>
<template>
  <b-dropdown
    right
    menu-class="dropdown-menu-lg "
    toggle-class="header-item noti-icon"
    variant="black"
  >
    <template v-slot:button-content>
      <div class="d-flex align-items-center">
        <i class="fab fa-wpforms mx-2" />
        <span class="text-light">{{ $t('FORMS') }}</span>
        <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
      </div>

      <app-add-to-cart-form-modal
        :product-id="selectedForm.id"
        :product="selectedForm"
        :visible.sync="showForm"
      />
    </template>
    <b-dropdown-header id="dropdown-header-label">
      {{ $t('Quick Add Forms') }}
    </b-dropdown-header>

    <template v-for="form in restForms">
      <b-dropdown-item :key="form.id" v-on:click="setSelectedForm(form)">
        <div class="d-flex align-items-center justify-content-between py-1">
          {{ form.short_description }}
        </div>
      </b-dropdown-item>
    </template>
  </b-dropdown>
</template>
